import React from 'react';

const variants = {
  success: 'bg-green-100 text-green-800 border-green-200',
  warning: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  error: 'bg-red-100 text-red-800 border-red-200',
  info: 'bg-blue-100 text-blue-800 border-blue-200',
  gray: 'bg-gray-100 text-gray-800 border-gray-200',
};

const sizes = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-2.5 py-1',
  lg: 'text-base px-3 py-1.5',
};

export function Badge({
  children,
  variant = 'gray',
  size = 'md',
  className = '',
  icon = null,
}) {
  return (
    <span
      className={`
        inline-flex items-center gap-1
        ${variants[variant]}
        ${sizes[size]}
        rounded-full border font-medium
        ${className}
      `}
    >
      {icon}
      {children}
    </span>
  );
}
